import React, { Component } from "react"
import axios from "axios"
import PanelView from "./PanelView"
import Loader from "../../components/loader"

class Panel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      user: null,
      orders: null,
      newOrder: {
        service: "",
        description: "",
        budget: "",
      },
      alert: null,
      initializing: true,
      formSubmitting: false,
    }
  }

  componentDidMount() {
    const token = localStorage.getItem("discord_token")
    if (!token) this.props.history.push("/")
    else {
      axios({
        method: "GET",
        url: `https://discordapp.com/api/users/@me?scope=identify%20email`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(res => {
        this.setState({ user: res.data }, () => {
          axios
            .get(
              `${process.env.REACT_APP_API_URL}/orders?id=${this.state.user.id}`
            )
            .then(ress => {
              let orders = ress.data.map(data =>
                JSON.parse(data.replace(/'/g, '"'))
              )
              this.setState({
                orders,
                initializing: false,
              })
            })
        })
      }).catch(err => {
        if(err.response.status === 401){
          this.logOut()
        }
      })
    }
  }

  logOut = () => {
    localStorage.removeItem("discord_token")
    this.props.history.push("/")
  }

  setAlert = alert => this.setState({ alert: { ...alert } })

  clearAlert = () => this.setState({ alert: null })

  rehydrateTable = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/orders?id=${this.state.user.id}`)
      .then(res => {
        let orders = res.data.map(data => JSON.parse(data.replace(/'/g, '"')))
        this.setState({
          orders,
        })
      })
  }

  onInputChange = elem => {
    const value =
      elem.target.type === "checkbox" ? elem.target.checked : elem.target.value
    const key = elem.target.name
    this.setState(state => ({
      newOrder: {
        ...state.newOrder,
        [key]: value,
      },
    }))
  }

  clearNewOrderForm = () =>
    this.setState({
      newOrder: {
        service: "",
        description: "",
        budget: "",
      },
    })

  submitNewOrder = e => {
    e.preventDefault()
    this.setState({ formSubmitting: true }, () =>
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/new?id=${this.state.user.id}&service=${this.state.newOrder.service}&descr=${this.state.newOrder.description}&budget=${this.state.newOrder.budget}`
        )
        .then(res => {
          if (res.data.status === "success") this.closeModal()
          this.rehydrateTable()
          this.setState({ formSubmitting: false })
          this.setAlert({
            type: res.data.status === "failed" ? "warning" : "success",
            title: res.data.status === "failed" ? "Warning!" : "Success!",
            message:
              res.data.status === "failed"
                ? res.data.message
                : `Your order has successfully been sent. Your order ID is ${res.data.message}.`,
            onConfirm: () => {
              if (res.data.status === "failed") this.clearAlert()
              else {
                this.clearNewOrderForm()
                this.clearAlert()
              }
            },
            onCancel: () => {
              if (res.data.status === "failed") this.clearAlert()
              else {
                this.clearAlert()
              }
            },
          })
        })
    )
  }

  openModal = () => this.setState({ showModal: true })

  closeModal = () => this.setState({ showModal: false })

  render() {
    return this.state.initializing ? (
      <Loader />
    ) : (
      <PanelView
        openModal={this.openModal}
        closeModal={this.closeModal}
        submitNewOrder={this.submitNewOrder}
        onChange={this.onInputChange}
        logOut={this.logOut}
        {...this.state}
      />
    )
  }
}

export default Panel



// WEBPACK FOOTER //
// ./src/routes/panel/Panel.js